import type { NavigateOptions } from '@tanstack/react-router';
import { getIdv2StoreData, setIdv2StoreData } from '@/idv2/features/idv-to-idv2';

export const pushIdentifyBack = (target: NavigateOptions) => {
  setIdv2StoreData({ identifyBackStack: [...(getIdv2StoreData()?.identifyBackStack ?? []), target] });
};

export const popIdentifyBack = (): NavigateOptions | undefined => {
  const stack = getIdv2StoreData()?.identifyBackStack ?? [];
  setIdv2StoreData({ identifyBackStack: stack.slice(0, -1) });
  return stack.at(-1);
};

/** Passing login, or starting over with another account, leaves nothing for Back to return to. */
export const clearIdentifyBack = () => {
  setIdv2StoreData({ identifyBackStack: [] });
};
